import React from 'react';
import { useIntl } from 'react-intl';

import Button from 'carbon-react/lib/components/button';

import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFormError } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-error/wizard-form-error';

interface AnalysisFeedbackLoadErrorScreenProps {
  onCancel: () => void;
  onRetryLoad: () => Promise<unknown> | void;
}

export const AnalysisFeedbackLoadErrorScreen = ({
  onCancel,
  onRetryLoad
}: AnalysisFeedbackLoadErrorScreenProps) => {
  const intl = useIntl();

  return (
    <WizardScreen footerMode={FooterMode.CREATED} onCancel={onCancel}>
      <>
        <WizardFormError
          message={intl.formatMessage({
            id: 'aiInsights.feedback.loadError',
            defaultMessage: 'We couldn’t load feedback for this analysis. Please try again.'
          })}
          mb={3}
        />
        <Button buttonType="secondary" onClick={onRetryLoad}>
          {intl.formatMessage({ id: 'common.tryAgain', defaultMessage: 'Try again' })}
        </Button>
      </>
    </WizardScreen>
  );
};
